import { repository } from 'src/jtech/jtech-repository'
import { JtechAxios } from 'src/plugins/axios'

export const SamaeRepository = {
  nmInterfaceImportFile: 'samae.importFile',
  nmInterfaceLisFile: 'samae.pesquisarFile',
  nmInterfaceLisUnit: 'samae.pesquisarUnits',
  nmInterfaceProcess: 'samae.importFile',
  nmInterfaceGerarDocumento: 'samae.gerarDocumento',
  nmInterfaceFinancialProcess: 'samae.startFinancialProcess',
  nmInterfaceExport: 'samae.exportFile',
  nmInterfaceJoinUnit: 'samae.joinUnit',
  nmInterfaceVerificaFileSamaeFinalizado: 'samae.verificaFileSamaeFinalizado',
  nmInterfaceUnitStateSamae: 'samae.unitStateSamae',
  nmInterfaceUnitStateSamaeDetalhar: 'samae.unitStateSamaeDetalhar',
  nmInterfaceAnalyze: 'samae.analyze',
  nmInterfaceStateSamaePesquisar: 'stateSamae.pesquisar',
  nmInterfaceUnitStateSamaeUnitDisabled: 'samae.unitStateSamaeUnitDisabled',
  nmInterfaceUnitStateSamaeClientChange: 'samae.unitStateSamaeClientChange',
  nmInterfaceUnitStateSamaeUnitNew: 'samae.unitStateSamaeUnitNew',
  nmInterfaceUnitStateSamaeUnitNewAssociate: 'samae.unitStateSamaeUnitNewAssociate',
  nmInterfaceFindConsumerUnitByConvag: 'consumerUnit.findConsumerUnitByCompanyCodeWater',
  nmInterfaceAlterPaymentType: 'consumerUnit.alterPaymentType',

  importFile: async function () {
    return await repository.resolve(this.nmInterfaceImportFile)
  },

  files: async function () {
    return await repository.resolveDatatable(this.nmInterfaceLisFile)
  },

  units: async function (params) {
    return await repository.resolveDatatable(this.nmInterfaceLisUnit, params)
  },

  processFile: async function (params) {
    return await repository.create(this.nmInterfaceProcess, params)
  },

  icGerarDocumento: async function (params) {
    return await repository.resolveLogic(this.nmInterfaceGerarDocumento, params)
  },

  icFinancialProcess: async function (params) {
    return await repository.resolveLogic(this.nmInterfaceFinancialProcess, params)
  },

  processExportFile: async function (nameFile) {
    return await this.exportFile(nameFile)
  },

  exportFile: async function (nameFile) {
    return await JtechAxios.request().get(`samae/exportFile/${nameFile}`, {
      responseType: 'blob',
      headers: { Accept: 'text/plain' }
    })
  },

  joinUnit: async function (params) {
    return await repository.resolveLogic(this.nmInterfaceJoinUnit, params)
  },

  unitStateSamae: async function (params) {
    return await repository.resolve(this.nmInterfaceUnitStateSamae, params)
  },

  unitStateSamaeDetail: async function (params) {
    return await repository.resolve(
      this.nmInterfaceUnitStateSamaeDetalhar,
      params
    )
  },

  analyze: async function (params) {
    return await repository.resolve(this.nmInterfaceAnalyze, params)
  },

  stateSamaes: async function (params) {
    return await repository.resolveDatatableModel(this.nmInterfaceStateSamaePesquisar, params)
  },

  unitStateSamaeUnitDisabled: async function (params) {
    return await repository.resolveLogic(this.nmInterfaceUnitStateSamaeUnitDisabled, params)
  },

  unitStateSamaeClientChange: async function (params) {
    return await repository.resolveLogic(this.nmInterfaceUnitStateSamaeClientChange, params)
  },

  unitStateSamaeUnitNew: async function (params) {
    return await repository.resolveLogic(this.nmInterfaceUnitStateSamaeUnitNew, params)
  },

  unitStateSamaeUnitNewAssociate: async function (params) {
    return await repository.resolveLogic(this.nmInterfaceUnitStateSamaeUnitNewAssociate, params)
  },

  unitAlterSamaeDisabledForm: async function (params) {
    return await repository.resolve(this.nmInterfaceUnitStateSamaeUnitDisabled, { ...params })
  },

  findConsumerUnitByConvag: async function (params) {
    return await repository.resolveDatatableModel(this.nmInterfaceFindConsumerUnitByConvag, { ...params })
  },

  alterPaymentType: async function (params) {
    return await repository.resolveLogic(this.nmInterfaceAlterPaymentType, { ...params })
  }
}
